import { ENVIRONMENT } from '@src/shared/src/const/app'

export const isEnvSearch = (env: ENVIRONMENT) => env === ENVIRONMENT.SEARCH